import { render } from "./CustomPopover.vue?vue&type=template&id=108de866&scoped=true"
import script from "./CustomPopover.vue?vue&type=script&lang=js"
export * from "./CustomPopover.vue?vue&type=script&lang=js"

import "./CustomPopover.vue?vue&type=style&index=0&id=108de866&scoped=true&lang=css"
import "./CustomPopover.vue?vue&type=style&index=1&id=108de866&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108de866"]])

export default __exports__